import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import {
	setModoTela, initForm
} from './preIncubacaoIdeacaoActions';
import {
	setModoTela as setModoTelaTrilaConhecimento
} from '../trilhaConhecimento/trilhaConhecimentoActions';

import TextoInput from '../texto/textoInput';

class PreIncubacaoIdeacaoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'
					style={{ padding: 0 }}>
					<ContentCard 
						style={{
							marginTop: 20,
							backgroundColor: '#0F2748',
							color: '#ffffff',
							borderRadius: 20,
							boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
							opacity: '80%'
						}}>
						<ContentCardHeader
							style={{
								marginTop: 16,
								marginBottom: 16
							}}>
							<label>{this.props.preIncubacaoIdeacaoFormTitulo}</label>
							
							{!this.props.modoAdm &&
							<TextoInput chave='preIncubacaoIdeacaoFormTitulo' />}
						</ContentCardHeader>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>
								
									<Field
										name='email'
										component={LabelAndInput}
										label='E-mail: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='nome_projeto'
										component={LabelAndInput}
										label='Nome do Projeto: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
										
									<Field
										name='responsavel'
										component={LabelAndInput}
										label='Nome do responsável pelo projeto: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='negocio'
										component={LabelAndTextarea}
										label='Descreva seu negócio: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='proposta'
										component={LabelAndTextarea}
										label='Descreva a sua proposta de solução para esse mercado: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='problema'
										component={LabelAndTextarea}
										label='Descreva o problema encontrado no mercado que pretende resolver, seja específico: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='mercado'
										component={LabelAndTextarea}
										label='Descreva o tamanho do mercado e seu crescimento e que percentual a sua empresa pretende atender: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='segmento'
										component={LabelAndTextarea}
										label='Descreva o segmento de clientes: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='fonte_receita'
										component={LabelAndTextarea}
										label='Descreva como pretende ganhar dinheiro. Descreva as fontes de receita: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='faturamento_ultimo_trimestre'
										component={LabelAndInputNumber}
										label='Informe o faturamento dos últimos três meses: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={2} />

									<Field
										name='custo_inicial'
										component={LabelAndTextarea}
										label='Quais são os principais custos para os primeiros meses: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='proximos_passos'
										component={LabelAndTextarea}
										label='Quais os próximos passos? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='vantagem_competitiva'
										component={LabelAndTextarea}
										label='Descreva a vantagem competitiva do seu mercado: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='atividades_momento'
										component={LabelAndTextarea}
										label='Descreva o que fez até o momento: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='metas'
										component={LabelAndTextarea}
										label='Quais as principais metas para os próximos meses? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='equipe'
										component={LabelAndTextarea}
										label='Descreva a sua equipe e o papel de cada um no projeto, mencionando as competências e quanto tempo cada um pretende dedicar ao negócio: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<Field
										name='investimento_inicial'
										component={LabelAndInputNumber}
										label='Valor necessário para o investimento inicial: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={2} />
									
									<Field
										name='visao'
										component={LabelAndTextarea}
										label='Visão do fututo: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<Field
										name='validou'
										component={Select}
										options={[
											{ id: 'Sim', valor: 'Sim' },
											{ id: 'Não', valor: 'Não' }
										]}
										label='Validou o problema: *' placeholder='' />
									
								</Row>
								
								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									{!this.props.modoAdm ? (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
										</Grid>
									) : (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => this.props.setModoTelaTrilaConhecimento('trilha')} />
										</Grid>
									)}
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

PreIncubacaoIdeacaoForm = reduxForm({form: 'preIncubacaoIdeacaoForm', destroyOnUnmount: false})(PreIncubacaoIdeacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('preIncubacaoIdeacaoForm')(state),
	registro: state.preIncubacaoIdeacao.registro,
	lista: state.preIncubacaoIdeacao.lista,
	preIncubacaoIdeacaoFormTitulo: state.texto.lista.filter(item => item.chave == 'preIncubacaoIdeacaoFormTitulo').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, 
	setModoTelaTrilaConhecimento
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PreIncubacaoIdeacaoForm);
